<template>
  <div id="lm-import-from-excel" v-if="showComponent">
    <p class="mb-3" v-if="label">{{ label }}</p>
    <div class="d-flex align-items-start">

      <b-input-group>
        <b-form-file
          v-model="file"
          :id="id"
          :disabled="disabled"
          :placeholder="placeholder"
          browse-text="Seleccionar"
          drop-placeholder="Arrastra tu archivo aqui..."
          :accept="acceptFiles"
        ></b-form-file>
        <b-input-group-append>
          <button class="reset-button" @click="file = null">Limpiar</button>
        </b-input-group-append>
      </b-input-group>

      <LmButton
        id="btn-import-excel"
        type="button"
        buttonClass="btn-primary ml-2 text-nowrap"
        :isProcessing="isLoading"
        :value="importButtonText"
        @click="onImportExcel"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
        icon="file-excel"
        :disabled="!Boolean(file)"
      />
      <LmButton
        v-if="availableFields.length"
        id="btn-download-excel-example"
        type="button"
        buttonClass="btn-secondary ml-2 text-nowrap"
        :value="downloadExampleButtonText"
        @click.native="onDownloadExample"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
        icon="download"
      />
    </div>
  </div>
</template>

<script>
import { json2excel } from 'js2excel'
import commonsApi from '@/api/commons'

import LmButton from '@/components/form/elements/LmButton'

import lmInputMixin from '@/mixins/lmInputMixin.js'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmInputMixin, lmToasts],
  components: {
    LmButton
  },
  props: {
    importButtonText: {
      type: String,
      default: 'Importar'
    },
    downloadExampleButtonText: {
      type: String,
      default: 'Descargar Ejemplo'
    },
    availableFields: {
      type: Array,
      default: () => []
    },
    customParams: {
      type: Array,
      default: () => []
    },
    uploadPath: {
      type: String,
      default: '/upload'
    },
    pathForPostRequest: {
      type: String,
      required: true
    },
    extraParamsToAppend: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      file: null,
      isLoading: false,
      // Acepta ".numbers", ".xlsx" o ".xls"
      acceptFiles: 'application/x-iwork-keynote-sffnumbers,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  },
  methods: {
    onDownloadExample () {
      this.isLoading = true
      try {
        if (this.availableFields.length) {
          const data = {}
          for (const af of this.availableFields) {
            data[af] = ''
          }
          json2excel({
            data: [data],
            name: 'lumbre-codificators-example'
          })
          this.lmToastSuccessMessage(`Se descargo un archivo de ejemplo correctamente!`, 'Acción exitosa')
        }
      } catch (error) {
        this.lmToastDangerMessage(error.message, 'Hubo un error')
      } finally {
        this.isLoading = false
      }
    },
    async onImportExcel () {
      this.isLoading = true
      try {
        const file = new FormData()
        file.append('file', this.file)
        const upload = await commonsApi.axiosPostWrapper(this.uploadPath, file, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.$store.state.session.accessToken}`
          }
        })

        const res = await commonsApi.axiosPostWrapper(this.pathForPostRequest, {
          file: upload.data.path,
          ...this.extraParamsToAppend
        })

        if (res.data.nModified) {
          this.lmToastSuccessMessage(`Se cargaron ${res.data.nModified} datos correctamente!`, 'Acción exitosa')
        }
        if (res.data.nError) {
          this.lmToastDangerMessage(`No pudimos cargar ${res.data.nError} datos. Asegurate de que sus nombres no esten duplicados.`, 'Falló la carga')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.reset-button
  background-color: #e9ecef
  border-radius: 0 0.25rem 0.25rem 0
  height: calc(1.5em + 0.75rem + 2px)
  padding: 0.375rem 0.75rem
  line-height: 1.5
  color: #495057
  border: 1px solid #ced4da
  box-shadow: none
  &:hover
    cursor: initial
  &:active
    color: #495057
    background-color: #e9ecef
    border: 1px solid #ced4da
</style>
